import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Modal } from '../../../store/models/Modal';
import { Product } from '../../../store/models/Product';
import Button from '../Button/Button';
import ProductItem from '../ProductItem/ProductItem';
import classes from './ProductPreviewModal.module.scss';

interface ProductPreviewModalProps {
  modal: Modal;
}

const ProductPreviewModal: FC<ProductPreviewModalProps> = ({ modal }) => {
  const { t } = useTranslation();
  const product = modal.data as Product;

  return (
    <div className={classes.Container}>
      <h4>{modal.title}</h4>
      <p className={classes.Text}>{t('products:product_preview_display')}</p>
      <ProductItem product={product} edit preview />
      <div className={classes.ButtonGroup}>
        <Button
          className={classes.Secondary}
          variant={'outlined'}
          onClick={modal.secondaryAction}
        >
          {t('common:back_editing')}
        </Button>
        <Button className={classes.Primary} onClick={modal.primaryAction}>
          {t('products:add_now')}
        </Button>
      </div>
    </div>
  );
};

export default ProductPreviewModal;
